import { getTime, formatDistanceToNow } from 'date-fns';
import moment from 'moment';

// ----------------------------------------------------------------------

function isValidDate(d) {
  // eslint-disable-next-line no-restricted-globals
  return d instanceof Date && !isNaN(d);
}

export function fDate(date, newFormat) {
  const fm = newFormat || 'DD MMM YYYY';

  return !(date && isValidDate(date)) ? moment(date).format(fm) : '-';
}

export function fDateTime(date, newFormat) {
  
  const fm = newFormat || 'DD MMM YYYY HH:mm';

  return !(date && isValidDate(date)) ? moment(date).format(fm) : '-';
}

export function fTimestamp(date) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : '';
}
